import { WarningDialog } from "@graffer-inc/console-design-kit";
import React from "react";
import { ProcedureTag } from "../../../../application/domain/proc-management";

type Props = {
  deleteTarget: ProcedureTag;
  onClose: () => void;
  onDelete: (id: string, pageNum: number) => void;
  pageNum: number;
};

export const ProcTagDeleteModal: React.FC<Props> = ({
  deleteTarget,
  onClose,
  onDelete,
  pageNum,
}) => {
  return (
    <WarningDialog
      title="手続きタグマスタの削除"
      proceedText="削除する"
      onProceed={() => onDelete(deleteTarget.id, pageNum)}
      cancelText="キャンセル"
      onCancel={onClose}
      contents={
        <div className="container">
          <p>
            {`「${deleteTarget.name}」のタグを削除します。タグを削除すると、手続きマスタからもこのタグの関連付けが削除されます。`}
          </p>
        </div>
      }
    />
  );
};

export default ProcTagDeleteModal;
